import { render, staticRenderFns } from "./AssignmentsIndex.vue?vue&type=template&id=43510829"
import script from "./AssignmentsIndex.vue?vue&type=script&lang=js"
export * from "./AssignmentsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports